const WelcomeScreenIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
		<path
			d="M3 12H16"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
		<path
			d="M12 8L16 12L12 16"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M19 5V19"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
		<path
			d="M16 4L22 4"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
		<path
			d="M16 20L22 20"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
	</svg>
);
export default WelcomeScreenIcon;